import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  // Account Setup
  {
    path: '/account-setup',
    name: 'Account Setup',
    component: () => import('../views/AccountSetup.vue'),
  },
  // How To Bid
  {
    path: '/how-to-bid',
    name: 'How To Bid',
    component: () => import('../views/HowToBid.vue'),
  },
  // Auctioneers
  {
    path: '/auctioneers',
    name: 'auctioneers',
    component: () => import('../views/Auctioneers.vue'),
  },
  // Auctions
  {
    path: '/auctions',
    name: 'auctions',
    component: () => import('../views/OnlineAuctions.vue'),
  },
  // Services
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/Services.vue'),
  },
  // Buyers
  {
    path: '/buyers',
    name: 'buyers',
    component: () => import('../views/Buyers.vue'),
  },
  // Sellers
  {
    path: '/sellers',
    name: 'sellers',
    component: () => import('../views/Sellers.vue'),
  },
  // Online Auctions
  {
    path: '/online-auctions',
    name: 'Online Auctions',
    component: () => import('../views/OnlineAuctions.vue'),
  },
  // Buying / Selling
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/Blog.vue'),
  },
  // Buying / Selling
  {
    path: '/buyers-information',
    name: 'buyers-information',
    component: () => import('../views/BuyersInformation.vue'),
  },
  // Contact
  {
    path: '/contact',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  // Subscribe
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import('../views/Subscribe.vue'),
  },
  // Page Ids
  {
    path: '/listings/:id',
    name: 'Listing',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingDetails.vue'),
  },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    meta: {
      hide: true,
    },
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
